import { render, staticRenderFns } from "./orders-split-list-view.vue?vue&type=template&id=41d6cee5&scoped=true"
import script from "./orders-split-list-view.vue?vue&type=script&lang=ts"
export * from "./orders-split-list-view.vue?vue&type=script&lang=ts"
import style0 from "./orders-split-list-view.vue?vue&type=style&index=0&id=41d6cee5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d6cee5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d6cee5')) {
      api.createRecord('41d6cee5', component.options)
    } else {
      api.reload('41d6cee5', component.options)
    }
    module.hot.accept("./orders-split-list-view.vue?vue&type=template&id=41d6cee5&scoped=true", function () {
      api.rerender('41d6cee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/orders-split-list-view.vue"
export default component.exports